import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FaSortDown, FaSortUp } from 'react-icons/fa';

const ColumnHead = ({ column, loading }) => {
  const [tip, setTip] = useState('');
  const renderedCell = useRef(null);
  const { Header, originalId, id, canSort, isSorted, isSortedDesc } = column;
  const cellProps = column.getHeaderProps(column.getSortByToggleProps());
  const { colSpan, key, onClick, style, title } = cellProps;

  useEffect(() => {
    if (renderedCell.current && renderedCell.current.offsetWidth < renderedCell.current.scrollWidth) {
      setTip(Header);
    }
  }, [Header, style]);

  return (
    <div
      className={`table__heading table__heading--${originalId || id}`}
      colSpan={colSpan}
      key={key}
      onClick={loading ? null : onClick}
      role="columnheader"
      style={column.style ? { ...style, ...column.style } : style}
      title={title}
      data-tip={tip}
      onKeyPress={loading ? null : onClick}
      tabIndex={canSort ? 0 : null}
      data-sticky-last-left-td={cellProps['data-sticky-last-left-td'] !== undefined ? cellProps['data-sticky-last-left-td'] : null}
      data-sticky-td={cellProps['data-sticky-td'] !== undefined ? cellProps['data-sticky-td'] : null}
    >
      {canSort ? (
        <div ref={renderedCell} style={{ outline: 'none' }}>
          {column.render('Header')}
          <div className="sort-icon">
            {(() => {
              if (isSorted) {
                return isSortedDesc ? <FaSortDown /> : <FaSortUp />;
              }
              return null;
            })()}
          </div>
        </div>
      ) : (
        <div ref={renderedCell}>
          {column.render('Header')}
          <div className="sort-icon" />
        </div>
      )}
    </div>
  );
};

ColumnHead.defaultProps = {
  loading: false,
};

ColumnHead.propTypes = {
  column: PropTypes.objectOf(PropTypes.any).isRequired,
  loading: PropTypes.bool,
};

export default ColumnHead;
